import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { Box, Card, useTheme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import useQuery from '@masfront/common-csr/router/hooks/useQuery'

import MainRoutes from './router/MainRoutes'

import { selectAgent } from '~/auth/store/auth.selectors'
import { useBrand } from '~/brand'
import { CustomerSidebar, CustomerSidebarSkeleton } from '~/customer/components'
import useCustomer from '~/customer/useCustomer'
import { getDocumentType } from '~/header/components/InputDocumentType/inputDocumentType.helpers'
import { CustomCircularProgress, ErrorMessage } from '~/ui/components'

const useStyles = makeStyles((theme) => {
  return {
    spinner: { margin: theme.spacing(60) },
    errorMessageCard: {
      height: '300px',
      borderRadius: '14px',
      padding: '30px 70px',
      borderBottom: `4px solid ${theme?.palette.error.main}`,
      width: '936px',
    },
  }
})

interface MainLoggedPageProps {
  customerIdentifier?: string
}

const MainLoggedPage: React.FC<MainLoggedPageProps> = ({ customerIdentifier = '' }) => {
  const theme = useTheme()
  const { brand } = useBrand()
  const classes = useStyles()
  const { getCustomer, customer, error, loading } = useCustomer()
  const { agent } = useSelector(selectAgent)
  const query = useQuery()
  const shouldRefresh = !!query.get('shouldRefresh')
  const documentInputType = getDocumentType(customerIdentifier)
  const history = useHistory()

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (documentInputType && customerIdentifier) {
      getCustomer({
        documentType: documentInputType,
        document: customerIdentifier,
        brand,
        sub: agent?.sub,
      })
    }
  }, [customerIdentifier, brand])

  useEffect(() => {
    if (documentInputType && customerIdentifier && shouldRefresh) {
      getCustomer({
        documentType: documentInputType,
        document: customerIdentifier,
        brand,
        sub: agent?.sub,
      })
      history.goBack()
    }
  }, [shouldRefresh])

  return (
    <Box>
      <Box display="flex" overflow="hidden" mt={`${theme.spacing(14)}px`}>
        {(loading || customer) && (
          <Box width={`${theme.spacing(98)}px`} height={`calc(100vh - ${theme.spacing(14)}px)`}>
            {customer && <CustomerSidebar customer={customer} />}
            {loading && <CustomerSidebarSkeleton />}
          </Box>
        )}
        {loading && (
          <Box width="100%" display="flex" justifyContent="center">
            <Box className={classes.spinner}>
              <CustomCircularProgress size={100} />
            </Box>
          </Box>
        )}
        {customer && (
          <Box height={`calc(100vh - ${theme.spacing(14)}px)`} width="100%" overflow="auto">
            <MainRoutes />
          </Box>
        )}
        {error && (
          <Box width="100%" mt={50} display="flex" justifyContent="center">
            <Card className={classes.errorMessageCard}>
              <ErrorMessage
                title="No se ha encontrado ningún cliente con el dato de búsqueda."
                subtitle="Por favor, inténtalo de nuevo."
              />
            </Card>
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default MainLoggedPage
